<template>
    <div class="wrapper-form-block-socios" :class="{'allow-markup-error': markupError}" :inert="pPreview">
        <div id="container-listagem-socios">
            <TrfListagemDeSociosCadastro
                :listagem-de-socios="formData.listagemDeSocios"
                :show-mais-acoes="!pPreview"
                :isVisualizacao="pIsConferencia"
                @elegalize-editar-formulario-socio.capture="emitEdicaoSocio"
                @elegalize-visualizar-formulario-socio.capture="emitEdicaoSocio"
                ref="form-block-socios"
            ></TrfListagemDeSociosCadastro>
            <p class="error-message" v-if="markupError">
                Campo obrigatório!
            </p>
        </div>
    </div>
  </template>
  <script>
  import { defineAsyncComponent } from 'vue';
  export default {
    name: 'TrfBlocoSocios',
    emits: ['update:form-data', 'set:validacao', 'edit:socio'],
    components: {
        TrfListagemDeSociosCadastro: defineAsyncComponent(() => import("../../../views/Legalize/CadastroDeProcessos/Components/ListagemDeSociosCadastro.vue"))
    },
    props: {
        pSocios: {
            type: Array,
            default: () => []
        },
        pPreview: {
            type: Boolean,
            default: true
        },
        pIsDirty: {
            type: Boolean,
            default: false
        },
        pIsConferencia: {
            type: Boolean,
            default: false
        },
        required: {
            type: Boolean,
            default: false
        }
    },
    data() {
      return {
        formData: {
            listagemDeSocios: this.pSocios
        },
        isDirty: this.pIsDirty
      };
    },
    computed: {
        hasSocios() {
            return Array.isArray(this.formData.listagemDeSocios) && this.formData.listagemDeSocios.length > 0
        },
        isInvalida() {
          if (!this.required) return false;
          return this.isDirty && !this.hasSocios
        },
        markupError() {
          return !this.pPreview && this.isInvalida
        }
    },
    watch: {
        pSocios: {
            immediate: true,
            handler(novo) {
                this.listagemDeSocios = novo
            },
            deep: true
        },
        pIsDirty: {
            immediate: true,
            handler(novo) {
                this.isDirty = novo
            }
        },
        isInvalida: {
            immediate: true,
            handler(novo) {
                if(this.required) {
                    this.$emit('set:validacao', !novo);
                }
            }
        }
    },
    methods: {
        setSocios(socios) {
            this.formData.listagemDeSocios = Array.isArray(socios)? socios : []; //garante tipo
            this.emitFormData(this.formData)
            this.isDirty = true
        },
        emitFormData(formData = this.formData) {
            this.$emit('update:form-data', formData)
        },
        emitEdicaoSocio(dadosModal) {
            this.$emit('edit:socio', dadosModal)
        }
    }
  };
  </script>
  